import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { catchError, map, Observable, shareReplay, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

export enum CancelType {
  CLIENT = 1,
  CAFLER = 2,
}

export enum CancelRefundType {
  Refund0 = 1,
  Refund100 = 2,
}


export interface CancelServiceOptionDTO {
  Code: string;
  Id: string;
}

export interface CancelServiceOption {
  code: string;
  id: string;
}

export interface CancelServicePayload {
  CancelReasonGuid: string;
  CancelType: CancelType; //  1 - 2
  RefundType: CancelRefundType | undefined; //  1 - 2 - undefined
  ReasonText: string | null;
}


@Injectable({
  providedIn: 'root'
})
export class CancelServiceService {

  private readonly productsUrl: string = environment.products_url;
  private readonly reasonsEndpoint = `${this.productsUrl}/api/cancellation-reasons`;
  private readonly trackingUrl: string = environment.tracking_url;

  private cache$?: Observable<CancelServiceOption[]>;


  constructor(private readonly http: HttpClient) { }

  getCancelReasons(): Observable<CancelServiceOption[]> {
    if (this.cache$) {
      return this.cache$;
    }

    this.cache$ = this.http
      .get<CancelServiceOptionDTO[]>(`${this.reasonsEndpoint}`)
      .pipe(
        map((items) => this.mapToOptions(items)),
        shareReplay(1),
        catchError((error) => {
          console.error('Error loading cancel reasons', error);
          return throwError(() => error);
        })
      );

    return this.cache$;
  }

  private mapToOptions(
    dtos: CancelServiceOptionDTO[] | null | undefined
  ): CancelServiceOption[] {
    if (!Array.isArray(dtos) || dtos.length === 0) {
      return [];
    }

    return dtos
      .filter((dto) => dto?.Code)
      .map((dto) => ({
        code: dto.Code,
        id: dto.Id,
      }));
  }

  cancelService(
    orderHash: string,
    payload: CancelServicePayload
  ): Observable<void> {
    return this.http.put<void>(
      `${this.trackingUrl}/service/${orderHash}/cancel`,
      payload
    );
  }
}
